/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Or_Continue_WithInputs */



/**
* | output |
* | --- |
* | "Or continue with" |
*
* @param {Auth_Or_Continue_WithInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_or_continue_with = /** @type {((inputs?: Auth_Or_Continue_WithInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Or_Continue_WithInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Oder fortfahren mit")
	return /** @type {LocalizedString} */ ("Or continue with")
});